import {OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { BaseEntity } from '../models/baseEntity';
import { Field } from '../models/dtos/field';

export abstract class BaseWidget implements OnInit {

    entityName      : string;
    orginalData     : any;
    currentData     : any;
    modifiedData    : boolean = false;  
    deletedData     : boolean = false;  
    isMainPage      : boolean = false; 
    requestService  : string  = null;

    confirmationMessage : string = "Confirmattion";
    

 //   @Input() editMode   : string = 'U';

    @Input() hideHeader : boolean = false;
    @Input() hideFooter : boolean = false;

    @Output() onClose = new EventEmitter<any>();

    @Input() actions = [];
    @Input() title = "Title ..";
    
    @Input() hideCloseButton : boolean = false;

    @Input()
    set data(data: any) {
      if (data !== null && data !== undefined) {
        this.setBaseEntity(data);
      }
    }
 
    @Input() columns      : Field[] = [];
    @Input() childFields  : Field[] = [];
    
    @Input() readOnly   : boolean = false;  
    

    constructor(    
      protected toastr            : ToastrService,
      protected leanUtilsService  : LeanUtilsService) {
        this.columns = null;
     }

     getField(fieldName  : string) : any{
       return this.leanUtilsService.getField(fieldName, this.columns);
   }

    ngOnInit() {
    }
  
    ngAfterViewInit() {
    }
    
    onClick(callback) {
            
    }
    
    beforeEdit(b  : boolean){}
    afterEdit(b  : boolean){}

    edit(b  : boolean) {

      this.requestService  = null;
      this.beforeEdit(b);
   
      if (b){
        this.getEntity().edit = true;
        this.getEntity().updated = true;
      } else {
        // We are leaving edit mode by Update cancelation or  Create cancelation
        this.setEntity(this.orginalData);
        if (this.getEntity().inserted){
               // Create cancelation
               this.close();
        } 
      }
      
      this.afterEdit(b);
    }

    editMode() : string {
      if (this.getEntity().inserted) {
          return 'I'; 
      }
      if (this.getEntity().edit) {
            return 'U'; 
      }
      return 'R';
    }

    validate(){
      if (! this.beforeValidate()) {
        return;
      }
      this.saveRow().then(result => {
        this.setBaseEntity(result);
        this.modifiedData     = true;
        this.showSuccessFulOperation();
        this.afterValidate();
      }); 
    }
    beforeValidate() : boolean{return true;}
    afterValidate(){}
    
    delete(){
      this.getEntity().deleted = true;
      
      this.saveRow().then(result => {
        this.showSuccessFulOperation();
        this.deletedData  = true;
        this.close();
      }).catch (err => {
        this.showError(err)
      });
    }


    setBaseEntity(data : BaseEntity){
      this.orginalData = data;
      this.setEntity(data);
    }

   abstract setEntity(data : BaseEntity);
   abstract getEntity() : BaseEntity;
   abstract saveRow() : Promise<BaseEntity>;


   close() {
    if (! this.deletedData) {
      this.onClose.emit(this.getEntity());
    } else {
      this.onClose.emit(null);
    }
  }
  
  showError(message : string){
    this.toastr.error(message);
  }
   
  showSuccessFulOperation(){
    this.toastr.success('Opération effectuée avec succès');
  }

  formatDate(d: Date){
    return this.leanUtilsService.dateTimePipe(d);
  }

}
